import { Link } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";
import { CONTACT_EMAIL } from "@/data/site";
import { FadeUp } from "@/components/site/Reveal";

const mailto = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent("Demande de création de site internet")}&body=${encodeURIComponent("Bonjour,\n\nJe souhaite créer un site internet pour mon activité : ...\n\nMes mots-clés pour le référencement : ...")}`;

export const ContactCta = () => (
  <section className="relative py-24 md:py-36 overflow-hidden" data-testid="contact-cta-section">
    <div className="glow-orb w-[700px] h-[400px] bg-blue-600/15 bottom-0 left-1/2 -translate-x-1/2" />
    <div className="max-w-4xl mx-auto px-6 md:px-10 text-center relative">
      <FadeUp>
        <p className="section-label mb-6">— Contact rapide</p>
      </FadeUp>
      <FadeUp delay={0.08}>
        <h2 className="font-display font-extrabold text-4xl md:text-6xl tracking-tight leading-[1.03]">
          Parlons de <span className="text-gradient">votre projet.</span>
        </h2>
      </FadeUp>
      <FadeUp delay={0.16}>
        <p className="text-[var(--text-secondary)] text-base md:text-lg mt-6 max-w-2xl mx-auto leading-relaxed">
          Un email suffit pour lancer la création de votre site internet. Décrivez-nous votre activité et vos envies —
          nous vous répondons rapidement avec un aperçu gratuit de votre futur site.
        </p>
      </FadeUp>
      <FadeUp delay={0.26}>
        <div className="flex flex-wrap items-center justify-center gap-4 mt-10">
          <Link
            to="/demande"
            className="btn-gradient inline-flex items-center gap-2.5 rounded-full px-8 py-4 font-semibold text-white"
            data-testid="contact-cta-form"
          >
            Faire une demande <ArrowRight size={17} />
          </Link>
          <a
            href={mailto}
            className="glass inline-flex items-center gap-2.5 rounded-full px-8 py-4 font-medium text-white/90 hover:bg-white/[0.07] transition-colors"
            data-testid="contact-cta-email"
          >
            <Mail size={16} /> {CONTACT_EMAIL}
          </a>
        </div>
      </FadeUp>
    </div>
  </section>
);

export default ContactCta;
